<mat-toolbar>
  <h1>Gym Finder Admin</h1>
  <div class="spacer"></div>
  <a
    mat-mini-fab
    color="primary"
    routerLink="/gym-location/gymfinder/search-filters"
    matTooltip="Gym finder search filters"
    *ngxPermissionsOnly="'editSearchFilters'">
    <mat-icon>filter_alt</mat-icon>
  </a>
</mat-toolbar>

<mat-card class="gymfinder-card">
  <mat-card-header class="gymfinder-card-header">
    <mat-card-title>Please select one of the options below</mat-card-title>
  </mat-card-header>

  <mat-card-content>
    <div>
      <mat-form-field class="form-column">
        <mat-label>Go to Gym ID</mat-label>
        <input
          #gymId
          matInput
          type="number"
          placeholder="Gym ID"
          (keydown.enter)="navigateToGymId(+gymId.value)" />
        <button
          matSuffix
          mat-raised-button
          color="primary"
          [disabled]="+gymId.value <= 0"
          (click)="navigateToGymId(+gymId.value)">
          <mat-icon>forward</mat-icon>
        </button>
      </mat-form-field>
    </div>

    <div>
      <button mat-raised-button color="primary" (click)="downloadCsv()">
        <mat-icon>table_view</mat-icon>
        Download all gyms as csv file
      </button>
    </div>
    @if (loading) {
      <mat-spinner [diameter]="30"></mat-spinner>
    }
    <ngx-adm-int-error [error]="error"></ngx-adm-int-error>
  </mat-card-content>
</mat-card>

<div class="add-report-button-container">
  <button
    mat-mini-fab
    color="primary"
    class="add-report-button"
    (click)="addGymReport()"
    matTooltip="Process multiple reports at once">
    <mat-icon>add</mat-icon>
  </button>
  @for (report of numberOfReports; track report) {
    <gymfinder-gym-report
    ></gymfinder-gym-report>
  }
</div>
